import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";

function VisibilityPhoto({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        [`${fieldName}_temp_path`]: uploadResult.temp_path
      }));
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const isFormValid = () => {
    // Check if both required photos are uploaded
    return !!primaryDetails.counter_top_photo_temp_path && !!primaryDetails.store_type_photo_temp_path;
  };
  const handleNext = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    
    // Check if required fields are filled
    if (!primaryDetails.counter_top_photo_temp_path || !primaryDetails.store_type_photo_temp_path) {
      toast.error("Please upload both photos.");
      return;
    }
    
    // if (!primaryDetails.revisit_detail) {
    //   toast.error("Please provide revisit details.");
    //   return;
    // }
    
    navigation.go("remarks");
  };

  const handleBack = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">VISIBILITY PHOTO</h4>
              <p className="form-desc">Please upload both visibility photos</p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">

                  {/* First Photo */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Merchandising Materials Visibility Photo (COUNTERTOP) <span className="form-required">*</span>
                      {primaryDetails.counter_top_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, "counter_top_photo")}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                  </Form.Group>

                  {/* Second Photo */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Merchandising Materials Visibility Photo (GLASS DOOR/KIOSK) <span className="form-required">*</span>
                      {primaryDetails.store_type_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, "store_type_photo")}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                  </Form.Group>

                  {/* Other RM Handling or Merchant Concerns */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Verbatim Feedback</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="feedback"
                      value={primaryDetails.feedback || ""}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setPrimaryDetails(prev => ({
                          ...prev,
                          [name]: value
                        }));
                      }}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                  {/* Revisit Details */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Revisit Details
                      {/* <span className="form-required">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="revisit_detail"
                      value={primaryDetails.revisit_detail || ""}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        setPrimaryDetails(prev => ({
                          ...prev,
                          [name]: value
                        }));
                      }}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                    {/* {primaryDetails.revisit_detail === "" && (
                      <div className="form-error">
                        Revisit details are required.
                      </div>
                    )} */}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      type="button"
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back 
                    </AppButton>
                    <AppButton
                      type="button"
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                       Next →
                    </AppButton>
                  </div>

                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default VisibilityPhoto;
